import React from "react";
import styled from "styled-components";
import { User } from "consumerhouse-shared";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUserNinja } from "@fortawesome/free-solid-svg-icons";
import { Badge } from "./Badge";
import { useLanguage } from "../useLanguage";
import { GroupContainer } from "./GroupContainer";

type UserCardProps = {
    user: User;
    style?: React.CSSProperties;
    admin?: boolean;
};

const Container = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;

const Header = styled.th`
    text-align: left;
    padding: 0 0.5em;
    font-size: 0.9em;
`;

const Capital = styled.span`
    text-transform: capitalize;
`;

const OuterContainer = styled.div`
    background: #0001;
    border-radius: 1em;
    padding: 1em;
    overflow: auto;
`;

export default function UserCard(props: UserCardProps) {
    const language = useLanguage();
    return (
        <OuterContainer style={props.style}>
            <Container>
                <FontAwesomeIcon style={{ margin: "0 0.8em 0.4em 0.4em", fontSize: "3em", opacity: 0.5 }} icon={faUser} />
                <table>
                    <tbody>
                        <tr>
                            <Header>{language("user-id")}</Header>
                            <td>{props.user.id}</td>
                        </tr>
                        <tr>
                            <Header>{language("user-name")}</Header>
                            <td>
                                {props.admin && props.user.admin && (
                                    <Badge icon={faUserNinja} color="#2a2">
                                        {language("user-admin")}
                                    </Badge>
                                )}{" "}
                                <Capital>{props.user.firstName}</Capital> <Capital>{props.user.lastName}</Capital>
                            </td>
                        </tr>
                        <tr>
                            <Header>{language("user-email")}</Header>
                            <td>{props.user.email}</td>
                        </tr>
                        <tr>
                            <Header>{language("user-telephone")}</Header>
                            <td>{props.user.telephoneNumber ?? "(ongekend)"}</td>
                        </tr>
                        <tr>
                            <Header>{language("user-iban")}</Header>
                            <td>{props.user.iban}</td>
                        </tr>
                        <tr>
                            <Header>{language("user-birthdate")}</Header>
                            <td>{new Date(props.user.birthTimeStamp).toLocaleDateString()}</td>
                        </tr>
                        <tr>
                            <Header>{language("user-gender")}</Header>
                            <td>{props.user.gender === "male" ? "Man" : "Vrouw"}</td>
                        </tr>
                        {props.admin && (
                            <tr>
                                <Header>{language("user-howfound")}</Header>
                                <td>{props.user.howFound}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </Container>
        </OuterContainer>
    );
}
